"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.setBackgroundOpen = exports.setOpen = exports.get = void 0;
var echoFonts_sidecar_1 = require("@echo/echoFonts-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var imports_1 = require("@lib/imports");
var clickEater_sidecar_1 = require("@uiParts/clickEater-sidecar");
var stevieTexts2_sidecar_1 = require("@uiParts/stevieTexts2-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var voyageUiCanvas_sidecar_1 = require("@voyage/ui/voyageUiCanvas-sidecar");
var voyageUiGButtons_sidecar_1 = require("@voyage/ui/voyageUiGButtons-sidecar");
var voyageUiMessage_sidecar_1 = require("@voyage/ui/voyageUiMessage-sidecar");
var voyageUiMultiListGames_sidecar_1 = require("@voyage/ui/voyageUiMultiListGames-sidecar");
var voyageGameManager_sidecar_1 = require("@voyage/game-status/voyageGameManager-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var spritesMenu_1 = require("@dive/spriteRecyclers/spritesMenu");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
        exports.setOpen(false);
        exports.setBackgroundOpen(false);
        render();
    }
    return _obj;
}
exports.get = get;
var create = function () {
    // TODO: new sprite
    // let sprite = largeSprites.goatBackgroundMenuMain
    // let spriteBackground = spritesUtil.createLargeSprite(
    //   voyageLayers.getLayers().uiMenuMain,
    //   sprite,
    // )
    // let tw = 1920 - 100
    // let th = 1080 - 200
    var tw = 400;
    var th = 300;
    var canvas = voyageUiCanvas_sidecar_1.voyageUiCanvas.create(tw, th, voyageLayers_sidecar_1.voyageLayers.getLayers().uiMenuMain);
    canvas.autoOffset = false;
    canvas.ox = 170; //1000
    canvas.oy = 240;
    var obj = voyageUiCanvas_sidecar_1.voyageUiCanvas.assign(canvas, {
        isMultiplayerOpen: false,
        multiplayerButtons: [],
        buttonMultiName: null,
        //spriteBackground,
    });
    var x = 20;
    var y = 40;
    var addButton = function (text, action) {
        var button = voyageUiGButtons_sidecar_1.voyageUiGButtons.create(text, x, y, action);
        button.w = 160;
        obj.buttons.push(button);
        y += 100;
        return button;
    };
    addButton('Singleplayer', function () {
        exports.setOpen(false);
        exports.setBackgroundOpen(false);
        websockets_sidecar_1.websockets.setSingleplayer(true);
        voyageGameManager_sidecar_1.voyageGameManager.goGame();
    });
    var tempX = x;
    var tempY = y;
    // if (obj.isMultiplayerOpen) {
    x += 200;
    obj.multiplayerButtons.push((obj.buttonMultiName = addButton('Name here', function () {
        var newName = prompt('What is your name?', voyageWebsockets_sidecar_1.voyageWebsockets.getMultiName()) || '';
        newName = newName.trim();
        if (newName) {
            if (newName.length > 128) {
                newName = newName.substring(0, 128);
            }
            websockets_sidecar_1.websockets.setMultiName(newName);
        }
    })));
    obj.multiplayerButtons.push(addButton('Host Game', function () {
        exports.setOpen(false);
        exports.setBackgroundOpen(false);
        websockets_sidecar_1.websockets.hostChannel('');
    }));
    obj.multiplayerButtons.push(addButton('Join Game', function () {
        voyageUiMultiListGames_sidecar_1.voyageUiMultiListGames.setOpen(true);
    }));
    // }
    x = tempX;
    y = tempY;
    addButton('Multiplayer', function () {
        obj.isMultiplayerOpen = !obj.isMultiplayerOpen;
    });
    addButton('Credits', function () {
        // \n\nAdditional Testing:
        var text = '';
        text += 'Designed and programmed by\n Stevie Bushman';
        text += '\n Keep Flying Games';
        text += '\n https://keepflyinggames.com';
        text += '\n\nAdditional sound effects from\n https://www.zapsplat.com';
        text +=
            '\n\nAdditional sound effects licensed from\n https://cafofomusic.itch.io';
        text +=
            "\n\nShip design inspired by\n Lazarus' Gabriel Fallen\n https://gm-lazarus.itch.io/gabriel-fallen";
        voyageUiMessage_sidecar_1.voyageUiMessage.setText('Credits', text);
        voyageUiMessage_sidecar_1.voyageUiMessage.setOpen(true);
    });
    addButton('v1.05 News', function () {
        // \n\nAdditional Testing:
        var text = '';
        text += '\n1.05 5/5/2021';
        text += '\n- add battle rifles';
        text += '\n- add coffee';
        text += '\n\n1.04 5/5/2021';
        text += '\n- flip star movement direction XD';
        text += '\n- add selection rectangle';
        text += '\n\n1.03 5/4/2021';
        text += '\n- zoom in / out with mouse wheel';
        text += '\n- pause with space';
        text += '\n\n1.02 5/3/2021';
        text += '\n- tutorial step for breach/fire';
        text += '\n\n1.01 5/3/2021';
        text += '\n- added flavor text for professions';
        text += '\n- death screen, basic ui fixes';
        text += '\n- decor';
        text += '\n\n1.00 5/3/2021';
        text += '\n- jam release';
        voyageUiMessage_sidecar_1.voyageUiMessage.setText('News', text);
        voyageUiMessage_sidecar_1.voyageUiMessage.setOpen(true);
    });
    addButton('Website', function () {
        window.open('https://keepflyinggames.com');
    });
    // addButton('Early Access', () => {
    //   goatUiMessage.setText(
    //     'Early Access',
    //     'You may encounter bugs and things may change!',
    //   )
    //   goatUiMessage.setOpen(true)
    // })
    return obj;
};
var render = function () {
    var obj = get();
    var g = obj.graphics;
    voyageUiCanvas_sidecar_1.voyageUiCanvas.clear(obj);
    var addText = function (text, x, y) {
        var _text = stevieTexts2_sidecar_1.stevieTexts2.create(echoFonts_sidecar_1.echoFonts.getData().font6, x, y, obj.layer);
        stevieTexts2_sidecar_1.stevieTexts2.setText(_text, text);
        stevieTexts2_sidecar_1.stevieTexts2.setScale(_text, 3);
        obj.texts.push(_text);
        return _text;
    };
    var x = 0;
    var y = 0;
    var w = 200;
    var h = 400;
    imports_1.l.forEach(obj.multiplayerButtons, function (c) {
        c.isVisible = obj.isMultiplayerOpen;
    });
    assert_sidecar_1.assert.notNil(obj.buttonMultiName);
    obj.buttonMultiName.text = 'Cmdr ' + voyageWebsockets_sidecar_1.voyageWebsockets.getMultiName();
    // voyageUiGraphicsUtils.bevelPanel(g, x, y, w, h)
    // addText('Main Menu', x + 6, y) // + 25 - 2)
    x = 300 + 20;
    y = 0;
    w = 1000 - 20;
    h = 400;
    voyageUiCanvas_sidecar_1.voyageUiCanvas.render(obj);
    spritesMenu_1.spritesMenu.getNext(100, 100, sprites_sidecar_1.sprites.diveTitleTitle[0]);
};
var setOpen = function (isOpen) {
    var obj = get();
    voyageUiCanvas_sidecar_1.voyageUiCanvas.setOpen(obj, isOpen);
    if (isOpen) {
        exports.setBackgroundOpen(true);
        // chessMusic.playMusicMenu()
    }
    else {
        // chessMusic.playMusic1()
    }
    exports.update();
};
exports.setOpen = setOpen;
var setBackgroundOpen = function (isOpen) {
    var obj = get();
    // obj.spriteBackground.visible = isOpen
    // obj.spriteBackground.visible = false
};
exports.setBackgroundOpen = setBackgroundOpen;
var update = function () {
    var obj = get();
    if (obj.isOpen) {
        var gb = voyageCamera_sidecar_1.voyageCamera.getGameBounds();
        // Adjust background image
        {
            var bw = 3440;
            var bh = 1440;
            var ox = (gb.width - bw) / 2;
            var oy = (gb.height - bh) / 2;
            // obj.spriteBackground.scale = 1
            // obj.spriteBackground.x = ox
            // obj.spriteBackground.y = oy
        }
        voyageUiCanvas_sidecar_1.voyageUiCanvas.update(obj);
        render();
        clickEater_sidecar_1.clickEater.tempEatCursor();
    }
    else {
        voyageUiCanvas_sidecar_1.voyageUiCanvas.clear(obj);
    }
};
exports.update = update;
